export default __webpack_public_path__ + "static/About-4a62c06b729bf6813c5337a3cb3ac5df.svg";